import { openBlock as r, createElementBlock as l, createElementVNode as e } from "vue";
const o = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function n(c, t) {
  return r(), l("svg", o, [...t[0] || (t[0] = [
    e("g", { "clip-path": "url(#a)" }, [
      e("path", {
        fill: "currentColor",
        d: "M14.333 4.8c.318 0 .635.018.943.063-1.783 1.944-2.81 4.482-2.81 7.137s1.027 5.193 2.81 7.137a6.5 6.5 0 0 1-.943.063c-4.116 0-7.466-3.231-7.466-7.2s3.35-7.2 7.466-7.2m0-1.8C9.181 3 5 7.032 5 12s4.181 9 9.333 9c1.699 0 3.295-.45 4.667-1.215-2.79-1.557-4.667-4.455-4.667-7.785S16.21 5.772 19 4.215A9.6 9.6 0 0 0 14.333 3"
      })
    ], -1),
    e("defs", null, [
      e("clipPath", { id: "a" }, [
        e("path", {
          fill: "currentColor",
          d: "M0 0h24v24H0z"
        })
      ])
    ], -1)
  ])]);
}
const s = { render: n };
export {
  s as default,
  n as render
};
